import React from 'react';
import style from './index.module.scss';
import classNames from 'classnames';
import { getAdaptUrl } from '../adaptImage';
import { isBoolean } from 'lodash';
import Image from '@/components/Image';
/**
 * @param props {
 *     loading:是否需要显示
 *     extraClassName: 额外设置骨架屏的classname
 *     extraStyle: 额外设置骨架屏的style
 * }
 * @returns <any>
 */
export function SkeletonDiv(
  props: React.HTMLAttributes<HTMLDivElement> & {
    loading?: boolean;
    extraClassName?: string;
    extraStyle?: React.CSSProperties;
    noRender?: boolean;
  },
) {
  const loadProps = { ...props };
  delete loadProps.loading;
  delete loadProps.extraClassName;
  delete loadProps.extraStyle;
  delete loadProps.noRender;
  if (props.loading) {
    delete loadProps.children;
    return (
      <div
        {...loadProps}
        className={classNames(props.className, style.content_placeholder, props.extraClassName)}
        style={{ ...props.style, ...props.extraStyle }}
      />
    );
  }
  if (props.noRender) {
    return null;
  }
  return <div {...loadProps} />;
}
/**
 * @param props {
 *     load:是否需要显示
 *     extraClassName: 额外设置骨架屏的classname
 *     extraStyle: 额外设置骨架屏的style
 * }
 * @returns <any>
 */
export function SkeletonImg(
  props: React.ImgHTMLAttributes<HTMLImageElement> & {
    load?: boolean;
    extraClassName?: string;
    extraStyle?: React.CSSProperties;
    noRender?: boolean;
    isAdapt?: boolean;
  },
) {
  const loadProps = { ...props };
  delete loadProps.load;
  delete loadProps.isAdapt;
  delete loadProps.extraClassName;
  delete loadProps.extraStyle;
  delete loadProps.noRender;
  if (props.load) {
    delete loadProps.children;
    return (
      <div
        {...loadProps}
        className={classNames(style.content_placeholder, style.display_line, props.className, props.extraClassName)}
        style={{ ...props.style, ...props.extraStyle }}
        onClick={(ee) => {
          ee.stopPropagation();
          return;
        }}
      />
    );
  }
  if (props.noRender) {
    return null;
  }
  if (!isBoolean(props?.isAdapt)) {
    props = {
      ...props,
      isAdapt: true,
    };
  }
  let url = props.src;
  if (props.isAdapt) {
    url = getAdaptUrl(props.src, Number(loadProps?.width));
  }
  return <Image {...loadProps} src={url} />;
}
/**
 * @param props {
 *     loading:是否需要显示
 *     extraClassName: 额外设置骨架屏的classname
 *     extraStyle: 额外设置骨架屏的style
 * }
 * @returns <any>
 */
export function SkeletonSpan(
  props: React.HTMLAttributes<HTMLSpanElement> & {
    loading?: boolean;
    extraClassName?: string;
    extraStyle?: React.CSSProperties;
    noRender?: boolean;
  },
) {
  const loadProps = { ...props };
  delete loadProps.loading;
  delete loadProps.extraClassName;
  delete loadProps.extraStyle;
  delete loadProps.noRender;
  if (props.loading) {
    delete loadProps.children;
    return (
      <div
        {...loadProps}
        className={classNames(style.content_placeholder, style.display_line, props.className, props.extraClassName)}
        style={{ ...props.style, ...props.extraStyle }}
      />
    );
  }
  if (props.noRender) {
    return null;
  }
  return <span {...loadProps} />;
}
